<cv-module-custom-setting-section *ngIf="moduleManager.settingsView === 'slideout' && initialized" [moduleManager]="moduleManager">
    <div class="custom-setting-section-title">
        <span cvLocalizedText langSection="Slideout_Settings" langKey="Date_Range">Date Range</span>
        <div class="body-2 mt-1 lato-regular">
            {{ getDateLocaleText(datesToCompare.firstDate.name) }},
            {{ getDateLocaleText(datesToCompare.secondDate.name) }},
            {{ getDateLocaleText(datesToCompare.thirdDate.name) }}
        </div>
    </div>
    <div class="custom-setting-section-body">
        <div class="custom-setting-section-body-row">
            <div class="custom-setting-section-body-row-label font-size-12">
                <div class="mb-2 font-size-12" style="display: inline-block;" cvLocalizedText langSection="Slideout_Settings" langKey="Select_Range">Select Date Range</div>
                <span class="font-size-12"> - {{ getDateLocaleText(datesToCompare.firstDate.name) }}</span>
            </div>
            <div class="custom-setting-section-body-row-input">
                <cv-date-range-selector *ngIf="availableDateRanges !== null && datesToCompare.firstDate"
                                        class="d-block mb-3"
                                        [pageName]="moduleKey + '_dr1' + '_temp'"
                                        [settingsManager]="settingsManager"
                                        [(selectedDateRange)]="datesToCompare.firstDate"
                                        [availableDateRanges]="availableDateRanges"
                                        (selectedDateRangeChange)="onDateChanged(datesToCompare.firstDate)"
                                        [multiDateRange]="superDateRange"
                                        [latestDate]="today"></cv-date-range-selector>
                                       
            </div>
        </div>
        <div class="custom-setting-section-body-row">
            <div class="custom-setting-section-body-row-label font-size-12">
                <div class="mb-2 font-size-12" style="display: inline-block;" cvLocalizedText langSection="Slideout_Settings" langKey="Compare_To">Compared to</div>
                <span class="font-size-12"> - {{ getDateLocaleText(datesToCompare.secondDate.name) }}</span>
            </div>
            <div class="custom-setting-section-body-row-input">
                <cv-date-range-selector *ngIf="availableDateRanges !== null && datesToCompare.secondDate"
                                        class="d-block mb-3"
                                        [pageName]="moduleKey + '_dr2' + '_temp'"
                                        [settingsManager]="settingsManager"
                                        [(selectedDateRange)]="datesToCompare.secondDate"
                                        [availableDateRanges]="availableDateRanges"
                                        (selectedDateRangeChange)="onDateChanged(datesToCompare.secondDate)"
                                        [multiDateRange]="superDateRange"
                                        [latestDate]="today"></cv-date-range-selector>
            </div>
        </div>
        <div class="custom-setting-section-body-row">
            <div class="custom-setting-section-body-row-label font-size-12">
                <div class="mb-2 font-size-12" style="display: inline-block;" cvLocalizedText langSection="Slideout_Settings" langKey="Compare_To">Compared to</div>
                <span class="font-size-12"> - {{ getDateLocaleText(datesToCompare.thirdDate.name) }}</span>
            </div>
            <div class="custom-setting-section-body-row-input">
                <cv-date-range-selector *ngIf="availableDateRanges !== null && datesToCompare.thirdDate"
                                        class="d-block mb-3"
                                        [pageName]="moduleKey + '_dr3' + '_temp'"
                                        [settingsManager]="settingsManager"
                                        [(selectedDateRange)]="datesToCompare.thirdDate"
                                        [availableDateRanges]="availableDateRanges"
                                        (selectedDateRangeChange)="onDateChanged(datesToCompare.thirdDate)"
                                        [multiDateRange]="superDateRange"
                                        [latestDate]="today"></cv-date-range-selector>
            </div>
        </div>
    </div>
</cv-module-custom-setting-section>
